var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from '@material-ui/core';
import { FlexCol, FlexPaper, isLocalhost } from '@xyo-network/sdk-xyo-react-js';
import { WindowSize } from '../components';
import { Copyright, FooterLinks, FooterLogo } from './components';
import FooterMenus from './menus';
export const Footer = (props) => {
    const { children, menus = true } = props, rootProps = __rest(props, ["children", "menus"]);
    return (_jsx(FlexPaper, Object.assign({ style: { borderRadius: 0 } }, rootProps, { children: _jsx(Container, Object.assign({ maxWidth: "lg" }, { children: _jsxs(FlexCol, Object.assign({ component: "footer", padding: 2 }, { children: [_jsx(FooterLogo, { display: "flex", padding: 2 }, void 0),
                    children,
                    menus ? _jsx(FooterMenus, { paddingY: 2 }, void 0) : null,
                    _jsx(Copyright, { paddingX: 2 }, void 0),
                    _jsx(FooterLinks, { paddingY: 2 }, void 0),
                    isLocalhost ? _jsx(WindowSize, {}, void 0) : null] }), void 0) }), void 0) }), void 0));
};
export default Footer;
